var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-chart',{ref:"chart",attrs:{"chart-type":"ColumnChart","columns":_vm.columns,"rows":_vm.rows,"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }